// extracted by mini-css-extract-plugin
export default {"report-category-hero":"ReportCategoryHero_report-category-hero__zcp2M","hero-title":"ReportCategoryHero_hero-title__sf3+I","hero-subtitle":"ReportCategoryHero_hero-subtitle__280qY"};